import { HTTP } from "./http";
import { getAuth } from "firebase/auth";
let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-medical.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-medical.php";
}

/**
 * Structured player medical information (Yes/No declaration + one entry per
 * condition with medication, dosage, triggers, emergency action).
 * Backed by back-end-endpoint-medical.php / lib/medical-lib.php.
 */
const Medical = {
  /** Fixed category list — mirrors MEDICAL_CATEGORIES in lib/medical-lib.php. */
  CATEGORIES: [
    { value: "allergy", label: "Allergy" },
    { value: "asthma", label: "Asthma / breathing" },
    { value: "diabetes", label: "Diabetes" },
    { value: "epilepsy", label: "Epilepsy / seizures" },
    { value: "heart", label: "Heart condition" },
    { value: "adhd_asd", label: "ADHD / autism / neurodiversity" },
    { value: "dietary", label: "Dietary requirement" },
    { value: "injury", label: "Ongoing injury / physical" },
    { value: "other", label: "Other" },
  ],
  SEVERITIES: [
    { value: "mild", label: "Mild" },
    { value: "moderate", label: "Moderate" },
    { value: "severe", label: "Severe" },
    { value: "life_threatening", label: "Life-threatening" },
  ],

  /** A blank condition row for the editor. */
  blankCondition() {
    return {
      category: "allergy",
      condition_name: "",
      severity: "",
      medication: "",
      dosage_instructions: "",
      carries_medication: null,
      triggers: "",
      emergency_action: "",
      notes: "",
    };
  },

  /**
   * The endpoint verifies the caller server-side, so every call carries the
   * signed-in user's Firebase ID token. Resolves to null when nobody is
   * signed in (the server then answers 401).
   */
  async idToken() {
    try {
      const user = getAuth().currentUser;
      return user ? await user.getIdToken() : null;
    } catch (e) {
      console.warn("Medical: could not get Firebase ID token", e);
      return null;
    }
  },

  async get(playerId) {
    const idToken = await this.idToken();
    return HTTP.post(API_SERVER, { action: "getMedical", playerId, idToken });
  },

  /**
   * @param {object} p { playerId, hasConditions, conditions, notes }
   * (clubId / updatedBy are derived server-side from the verified token.)
   */
  async save(p) {
    const idToken = await this.idToken();
    return HTTP.post(API_SERVER, { action: "saveMedical", ...p, idToken });
  },
};

export { Medical };
